import PortalIdParser from 'PortalIdParser';
import { getOwnerIdFromUserId } from 'calling-integration-sdk-support/remote-interface/http/fetchOwnerId';
import { getSetting } from 'calling-internal-common/utils/localSettings';
const LOCAL_SETTINGS_PREFIX = 'LocalSettings:Sales:';
export function getOwnerIdFromCache({
  userId
}) {
  const key = `OID:${userId}:${PortalIdParser.get()}`;
  const cachedId = getSetting(key, undefined, undefined, LOCAL_SETTINGS_PREFIX);
  const ownerId = Number(cachedId);
  if (!isNaN(ownerId) && ownerId > 0) {
    return Promise.resolve(ownerId);
  }
  return getOwnerIdFromUserId(userId).then(response => response[0].ownerId).catch(() => 0);
}